import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import BoosterFooter from "../../components/booster-footer/component";
import BoosterHeader from "../../components/booster-header/component";
import {dataRegister} from "../../services/dataRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class BoosterAbout extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {
        window.scrollTo(0, 0);

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/about');
            ReactGA4.send({ hitType: "pageview", page: "/about" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
    }

    _renderText(item) {
        return langRegister.get("booster-about", item);
    }

    render() {
        return (
              <div className={Styles.view}>
                  <BoosterHeader view={"about"} props={this.props}/>
                  <div className={Styles.sectionOne}>
                      <div className={Styles.sectionOneInner}>
                          <div className={Styles.sectionOneText}>
                              <div className={Styles.sectionOneTextInner}>
                                  <div >
                                      {this._renderText("item_1")}{" "}<br className={Styles.sectionOneTextInnerMobile}/>
                                      <span className={Styles.sectionOneTextGreen}>{this._renderText("item_2")}</span>
                                  </div>
                                  <div className={Styles.sectionOneTextGreenSmall}>
                                      {this._renderText("item_3")}
                                  </div>
                                  <div onClick={() => this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang())} className={Styles.sectionOneButton}>
                                      {this._renderText("item_4")}
                                  </div>
                              </div>
                          </div>
                          <div className={Styles.sectionOneFiller}/>
                          <div className={Styles.sectionOneImage}>
                              {
                                  salesChannelRegister.get('name') === "yieldlock" &&
                                  <img className={Styles.sectionOneImageItem} src={require("../../assets/images/YL_lock-1.png")}/>
                              }
                              {
                                  salesChannelRegister.get('name') === "propertybooster" &&
                                  <img className={Styles.sectionOneImageItem} src={require("../../assets/images/PB_megafon.png")}/>
                              }
                              {
                                  salesChannelRegister.get('name') === "boostabostad" &&
                                  <img className={Styles.sectionOneImageItem} src={require("../../assets/images/BB_megafon.png")}/>
                              }
                          </div>
                      </div>
                  </div>
                  <div className={Styles.sectionTwo}>
                      <div className={Styles.sectionTwoInner}>
                          <div className={Styles.sectionTwoImage}>
                              {
                                  salesChannelRegister.get('name') === "yieldlock" &&
                                  <img className={Styles.sectionTwoImageItem} src={require("../../assets/images/YL_atyourservice_Desktop-1.png")}/>
                              }
                              {
                                  salesChannelRegister.get('name') === "propertybooster" &&
                                  <img className={Styles.sectionTwoImageItem} src={require("../../assets/images/PB_greet.png")}/>
                              }
                              {
                                  salesChannelRegister.get('name') === "boostabostad" &&
                                  <img className={Styles.sectionTwoImageItem} src={require("../../assets/images/BB_greet.png")}/>
                              }
                          </div>
                          <div className={Styles.sectionTwoFiller}/>
                          <div className={Styles.sectionTwoText}>
                              {this._renderText("item_5")}
                              <div className={Styles.sectionTwoTextBread}>
                                  {this._renderText("item_6")}
                              </div>
                          </div>
                      </div>
                  </div>
                  <div className={Styles.sectionThree}>
                      <div className={Styles.sectionThreeInner}>
                          <div className={Styles.sectionThreeText}>
                              <div className={Styles.sectionThreeTextInner}>
                                  {this._renderText("item_7")}
                                  <span className={Styles.sectionThreeTextGreen}>{this._renderText("item_8")}</span>
                                  {this._renderText("item_9")}{" "}
                                  <span className={Styles.sectionThreeTextGreen}>{this._renderText("item_12")}</span>
                                  {" "}
                                  {this._renderText("item_11")}
                                  <div className={Styles.sectionThreeTextSmall}>
                                      {this._renderText("item_13")}
                                  </div>
                                  <div onClick={() => this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang())} className={Styles.sectionThreeButton}>
                                      {this._renderText("item_14")}
                                  </div>
                              </div>
                          </div>
                          <div className={Styles.sectionThreeImage}>
                              {
                                  salesChannelRegister.get('name') === "yieldlock" &&
                                  <img className={Styles.sectionThreeImageItem} src={require("../../assets/images/YL_no1innovtor_EN.png")}/>
                              }
                              {
                                  salesChannelRegister.get('name') === "propertybooster" &&
                                  <img className={Styles.sectionThreeImageItem} src={require("../../assets/images/PB_amplify.png")}/>
                              }
                              {
                                  salesChannelRegister.get('name') === "boostabostad" &&
                                  <img className={Styles.sectionThreeImageItem} src={require("../../assets/images/BB_amplify.png")}/>
                              }
                          </div>
                      </div>
                  </div>
                  <BoosterFooter props={this.props}/>
              </div>
        );
    }
}

export default BoosterAbout;


// WEBPACK FOOTER //
// ./src/pages/booster-about/component.js